import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import Block from '../Misc/Block.js';
import { Input, Alert } from 'antd';

const { TextArea } = Input;

class BlockSummary extends Component {

  state = {
    text: this.props.text || ''
  }

  componentDidMount(){
    const {summaries} = this.props.entries;
    const {blocks} = this.props.entries.blocks;

    if(this.props.data.blockBreaks){
      this.props.breakLines(this.props.data.blockBreaks, 'BREAK_LINES_SUMMARY');
    }

    let disabled = true;

    if(blocks === undefined)
      return

    //If summaries exist and aren't empty allow saving
    if(Object.keys(summaries).length === blocks.length){
      const empty = Object.values(summaries).findIndex((ele) => ele === '');
      if(empty === -1)
        disabled = false;
    }

    this.props.updateSummaries(summaries, disabled);
  }

  handleSummaryChange(e, key){
    let {summaries, blocks} = this.props.blockSummary;

    blocks = blocks ? blocks.blocks : this.props.entries.blocks.blocks;

    let disabled = true;

    const payload = Object.assign({}, summaries, { [key]: e.target.value });

    if(Object.keys(payload).length === blocks.length){
      const empty = Object.values(payload).findIndex((ele) => ele === '');
      if(empty === -1)
        disabled = false;
    }

    this.props.updateSummaries(payload, disabled);
  }

  renderBlocks(){
    //if no blocks saved and no blocks set in component data, return alert
    if(!this.props.entries.blocks.blocks && !this.props.blockSummary.blocks)
      return <Alert className="block-summary-alert" showIcon type="error" message="No blocks submitted" />;

    const source = this.props.entries.blocks.blocks ? this.props.entries.blocks : this.props.blockSummary.blocks;

    const {blocks, offsets} = source;

    return blocks.map((block, index) => {
      let offset = offsets ? offsets[index] : false;
      const defaultValue = this.props.entries.summaries[index];

      return [
        <Block
          key = {'block' + index}
          block = {index+1}
          className = 'poem block'
          lines={block}
          offset={offset}
        />,
        <TextArea
          placeholder="Type summary of above block"
          defaultValue = {defaultValue}
          id = {'summary' + index}
          key = {'summary' + index}
          className = "block-summary-input"
          type = "textarea"
          onChange = {(e) => this.handleSummaryChange(e, index)}
          rows = {2}
          autosize={{ minRows: 2, maxRows: 4 }}
        />
      ];
    });
  }

  render(){
    return (
      <div id="BlockSummary">
        <h2 className="title">{this.props.text.title}</h2>
        {this.renderBlocks()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    blockSummary: state.blockSummary,
    entries: state.entries,
    text: state.course.text
  };
}

export default connect(mapStateToProps, actions)(BlockSummary);



// WEBPACK FOOTER //
// ./src/components/BlockSummary/BlockSummary.js